import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestMultipleChoiceDemo from './TestMultipleChoiceDemo'
import TestMultipleChoiceEditorActions from './TestMultipleChoiceEditorActions'
import TestMultipleChoiceElement from './TestMultipleChoiceElement'
import TestMultipleChoiceFormBrand from './TestMultipleChoiceFormBrand'
import { STYLE_FORM_SCHEMA } from './TestMultipleChoiceFormStyle'
import TestMultipleChoiceFormValue from './TestMultipleChoiceFormValue'
import testMultipleChoiceIcon from './assets/testMultipleChoice.svg'

export default genElementConfig(CONFIG_ELEMENTS.testMultipleChoice, {
  label: t('elements.testMultipleChoice.label'),
  icon: testMultipleChoiceIcon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestMultipleChoiceElement,
  Demo: [TestMultipleChoiceDemo],
  FormValue: TestMultipleChoiceFormValue,
  FormBrand: TestMultipleChoiceFormBrand,
  EditorActions: TestMultipleChoiceEditorActions,
})
